import * as actions from './actions'

export default function($api) {
  let dispatchers = {}
  Object.keys(actions).forEach(scope => {
    dispatchers = { ...dispatchers, ...actions[scope]($api) }
  })

  return dispatchers
}



// WEBPACK FOOTER //
// ./src/api/dispatch.js